export default __webpack_public_path__ + "static/media/PortoHolding-RGB-H.be3da7f1.png";